import script from "./CheckView.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckView.vue?vue&type=script&setup=true&lang=js"

import "./CheckView.vue?vue&type=style&index=0&id=b3f96c7e&lang=scss"

const __exports__ = script;

export default __exports__